import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import NavBar from "components/navbar/NavBar";
import SideBar from "components/sidebar/Sidebar";
import {
  useGetGameLazyQuery,
  useGetGameStatsLazyQuery,
  useGetGamesQuery,
  useGetAllPartiesQuery,
} from "generated/graphql";
import { useContext, useState } from "react";
import { LoggedInUserContext } from "contexts/user";

const LeaderboardPageWrapper = styled.div`
  /* Game filter */

  .game-filter-container {
    margin-left: 250px;

    button {
      background: none;
      border: 0;
      cursor: pointer;
      padding: 0;
      margin: 0;
    }
  }

  .game-filter-container img {
    /* width: 100px; */
    height: 134px;
    padding-right: 30px;
  }

  /* Floating Navbar */

  .tourn_float_navbar {
    position: relative;
    overflow: hidden;
    background-color: #1d2029;
    margin-left: 250px;
    margin-right: 150px;
    height: 40px;
    border-radius: 50px;
    margin-top: 20px;
  }

  .tourn_float_links a {
    float: none;
    position: relative;
    top: 50%;
    left: 5%;
    top: 12px;
    color: #ffffff;
    text-decoration: none;
    font-weight: 600;
  }

  .tourn_float_links2 a {
    float: none;
    position: relative;
    top: 50%;
    left: 42%;
    top: -8px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
  }

  .tourn_float_links2 a:hover {
    color: #ffffff;
  }

  .tourn_float_links3 a {
    float: none;
    position: relative;
    top: 50%;
    left: 85%;
    top: -28px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
  }

  .tourn_float_links3 a:hover {
    color: #ffffff;
  }

  /* Leaderboard */

  table {
    background: #1d2029;
    border-collapse: collapse;
    width: 60%;
    margin-left: 250px;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  td,
  th {
    border: 1px solid #7d7d7d;
    text-align: left;
    padding: 8px;
    width: 200px;
  }

  th {
    color: #7d7d7d;
  }

  /* Seasonal Leaderboard */

  #seasonTable h2 {
    margin-left: 500px;
    margin-top: 50px;
  }

  #team_size {
    margin-left: 830px;
    margin-top: 20px;
    color: #ffffff;
    background-color: #1d2029;
    height: 35px;
    border: #1d2029 0;
    border-radius: 3px;
  }

  /* Tournament Leaderboard */

  #tournamentTable h2 {
    margin-left: 500px;
    margin-top: 50px;
  }

  #team_size1 {
    margin-left: 770px;
    margin-top: 20px;
    color: #ffffff;
    background-color: #1d2029;
    height: 35px;
    border: #1d2029 0;
    border-radius: 3px;
  }
`;

function LeaderboardPage() {
  const [activeSection, setActiveSection] = useState("all-time");

  const me = useContext(LoggedInUserContext);
  const { data: games, loading: loadingGames } = useGetGamesQuery({ nextFetchPolicy: "cache-first"});
  const [
    getGameStats,
    { data: gameLeaderboard, loading: loadingGameLeaderboard },
  ] = useGetGameStatsLazyQuery();
  const [getGame, { data: game }] = useGetGameLazyQuery();
  let { data: parties, loading: loadingParticipants } = useGetAllPartiesQuery();
  // @ts-ignore
  parties =
    !loadingParticipants && parties!
      ? parties.parties.reduce(
          (acc, val) => ({ ...acc, [val.id]: val.nickname }),
          {}
        )
      : {};
  const [activeGame, setActiveGame] = useState(undefined);

  let leaderboardStats =
    !loadingGameLeaderboard &&
    gameLeaderboard &&
    gameLeaderboard?.getGameStats?.stats!.length! > 0
      ? [...gameLeaderboard?.getGameStats?.stats!]
      : [];
  return (
    <LeaderboardPageWrapper>
      <Helmet>
        <title>Tournaments — Jiwe eSports</title>
      </Helmet>
      <div className="wrapper">
        <SideBar
          nickname={me?.nickname}
          isLoggedIn={!!me?.nickname}
        />
        {me && (
          <NavBar nickname={me?.nickname} name={me?.name} />
        )}
      </div>

      <div className="game-filter-container">
        <h3>Filter by game</h3>
        {!loadingGames &&
          games?.games.map((g) => (
            <button
              key={g.id}
              onClick={() => {
                setActiveGame(g.id);
                getGame({ variables: { gameId: g.id } });
                getGameStats({ variables: { gameId: g.id } });
              }}
            >
              <img
                src={g.poster_url!}
                alt=""
                style={{
                  filter: activeGame === g.id ? "grayscale(0)" : "grayscale(1)",
                  opacity: activeGame === g.id ? 1 : 0.5,
                }}
              />
            </button>
          ))}
        <br />
        {!!game?.game && (
          <h3 style={{ fontWeight: "bold", marginTop: "2em" }}>
            {game?.game?.name} Leaderboard
          </h3>
        )}
      </div>

      {activeGame && games?.games && game && (
        <>
          <div className="tourn_float_navbar">
            <div className="tourn_float_links">
              <a
                className="active"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("all-time");
                }}
                href="/"
              >
                All Time
              </a>
            </div>
            <div className="tourn_float_links2">
              <a
                className="active"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("seasonal");
                }}
                href="/"
              >
                Seasonal
              </a>
            </div>
            <div className="tourn_float_links3">
              <a
                className="active"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection("tournament");
                }}
                href="/"
              >
                Tournament
              </a>
            </div>
          </div>
          {activeSection === "all-time" && (
            <table id="alltimeTable">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Points</th>
                  <th>KDA</th>
                  <th>Game Record</th>
                  <th>W/L Ratio</th>
                  <th>Cash Won</th>
                </tr>
              </thead>
              <tbody>
                {!loadingGameLeaderboard &&
                  leaderboardStats.map((stat, index) => (
                    <tr key={stat.id}>
                      <td>{index + 1}</td>
                      <td>
                        {
                          // @ts-ignore
                          parties![stat.id!]
                        }
                      </td>
                      <td>{stat.scores.global.points}</td>
                      <td>{stat.scores.global.kda}</td>
                      <td>
                        {stat.scores.global.matchesPlayed
                          ? stat.scores.global.wins /
                            stat.scores.global.matchesPlayed
                          : 0}
                      </td>
                      <td>{stat.scores.global.winLossRatio}</td>
                      <td>-</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}

          {activeSection === "seasonal" && (
            <div id="seasonTable">
              {/* <label for="team" class="t_y">
                Filter by Season:
              </label>
              <select name="team_size" id="team_size">
                <option value="one">2019 off Season EA League</option>
                <option value="two">2020 Summer EA League</option>
              </select> */}
              <h2>Seasonal Leaderboard will display here</h2>
            </div>
          )}

          {activeSection === "tournament" && (
            <div id="tournamentTable">
              <label htmlFor="team">Select tournament:</label>

              <select name="team_size" id="team_size1">
                {game?.game?.tournaments.map((tournament) => (
                  <option key={tournament.id} value={tournament.id}>
                    {tournament.name}
                  </option>
                ))}
              </select>
              <h2>Tournament Leaderboard will display here</h2>
            </div>
          )}
        </>
      )}
    </LeaderboardPageWrapper>
  );
}

export default LeaderboardPage;
